import {PublicConfig} from "~/utils/types/config";

export const useRequestOptions = (post = true) => {

  const config: PublicConfig = useRuntimeConfig().public as PublicConfig;

  const requestOptions: RequestOptions = {
    method: post ? 'POST' : 'GET',
    baseURL: config.api_url
  };

  return requestOptions
}
